<div class="container-fluid ">
    <div class="row border rounded-1 background-light my-3 p-3">
        <mat-form-field class="col">
            <mat-label>Date de début</mat-label>
            <input matInput placeholder="Date de début" [matDatepicker]="picker" [(ngModel)]="FromDate" (focus)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Date de fin</mat-label>
            <input matInput placeholder="Date de fin" [matDatepicker]="picker1" [(ngModel)]="ToDate" (focus)="picker1.open()">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Type de prestation</mat-label>
            <mat-select placeholder="Type de prestation" [(ngModel)]="InterventionType" (selectionChange)="selectedInterventionType($event)">
                <mat-option [value]="INTERVENTION_TYPE_ALL">
                    <span>Toutes </span>
                </mat-option>
                <mat-option *ngFor="let p of InterventionTypeList; let i = index" [value]="i + 1">
                    <span>{{p}} </span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Nom de client</mat-label>
            <input matInput placeholder="Nom de client" [(ngModel)]="SearchText" [matAutocomplete]="auto" (keyup)="onKeyUp()" [disabled]="!FromDate || !ToDate">
            <!-- <button mat-button *ngIf="SearchText && IsCreation" matSuffix mat-icon-button aria-label="Clear" (click)="SearchText=''">
                <mat-icon>close</mat-icon>
            </button> -->
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedClient($event)" [displayWith]="displayFn">
            <mat-option *ngFor="let client of ClientList" [value]="client">
                {{ client.ELIMSData?.ClientName}} - {{ client.ELIMSData?.ClientZipCode}} - {{ client.ELIMSData?.ClientCity}}
            </mat-option>
        </mat-autocomplete>
    </div>
    <div class="row justify-content-center">
        <button *ngIf="InterventionType === EInterventionType.MPCE || InterventionType === EInterventionType.MGCE ||InterventionType === undefined" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                (throttledClick)="generateExport(EExportType.SaisieMinVCEE)" [disabled]="!CanGenerate">
            Saisie MInvCE (Groupé)
        </button>
        <button *ngIf="InterventionType === EInterventionType.MPCE || InterventionType === EInterventionType.MGCE || InterventionType === undefined" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                (throttledClick)="generateExport(EExportType.SaisieMinVCEEGrouped)" [disabled]="!CanGenerate">
            Saisie MInvCE (Non Groupé)
        </button>
        <button *ngIf="InterventionType === EInterventionType.MPCE || InterventionType === undefined" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                (throttledClick)="generateExport(EExportType.SoutienBioMinVCE)" [disabled]="!CanGenerate">
            Soutien Bio MInvCE
        </button>
        <button *ngIf="InterventionType === EInterventionType.IBD || InterventionType === undefined" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                (throttledClick)="generateExport(EExportType.SoutienBioDiat)" [disabled]="!CanGenerate">
            Soutien Bio Diat
        </button>
        <button *ngIf="InterventionType === EInterventionType.IBD || InterventionType === undefined" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                (throttledClick)="generateExport(EExportType.EchangeListe)" [disabled]="!CanGenerate">
            Echange Liste Diat
        </button>
        <button *ngIf="InterventionType === EInterventionType.IBMR || InterventionType === undefined" appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent"
                (throttledClick)="generateExport(EExportType.SaisieMphytCE)" [disabled]="!CanGenerate">
            Saisie MphytCE
        </button>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent" (throttledClick)="generateExport(EExportType.OSUR)" [disabled]="!CanGenerate">
            OSUR
        </button>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent" (throttledClick)="generateExport(EExportType.RE)" [disabled]="!CanGenerate">
            RE
        </button>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent" (throttledClick)="generateExport(EExportType.RI)" [disabled]="!CanGenerate">
            RI
        </button>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="accent" (throttledClick)="generateExport(EExportType.RP)" [disabled]="!CanGenerate">
            RP
        </button>
        <button appPreventDoubleClick class="col-auto m-2" mat-raised-button color="warn" (throttledClick)="getALL()">
            ALL INTER
        </button>
    </div>
    <div class="row justify-content-center my-5">
        <div class="col col-md-6 col-xl-4 " *ngFor="let i of InterventionList">
            <div class="card w-100 m-1">

                <h5 class="card-header d-flex justify-content-between">
                    <span>{{i.ELIMSData.StationCode}}</span>
                    <mat-checkbox [(ngModel)]="i.IsSelected"></mat-checkbox>
                </h5>

                <div class="card-body">
                    <h5 class="card-title">{{i.SampleCode}}</h5>
                    <p class="card-text">{{i.ELIMSData.StationName}}</p>
                    <p class="card-text">{{SelectedClient?.ELIMSData?.ClientName}}</p>
                    <p class="card-text">{{i.PartnerCode}}</p>
                </div>

                <div class="row d-flex justify-content-end g-0">
                    <span class="card-text me-3 col-auto"><small class="text-muted">{{i.Date | date}}</small></span>
                </div>
                <div style="height: 5px" [style.background]="getColorByInterventionStatus(i.Type)"></div>

            </div>
        </div>
    </div>
</div>